module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-04.d7927fc7.png";